import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  prompt: "",
  sending: false,
  newCode: null,
};

const codeEditorSlice = createSlice({
  name: "codeEditor",
  initialState: initialState,
  reducers: {
    setPrompt(state, action) {
      state.prompt = action.payload;
    },
    setSending(state, action) {
      state.sending = action.payload;
    },
    setNewCode(state, action) {
      state.newCode = action.payload;
    },
  },
});

export const codeEditorActions = codeEditorSlice.actions;

export default codeEditorSlice.reducer;
